<div class="team-list">
  <mtg-team-card
    *ngFor="let team of teams"
    [team]="team"
    [access]="access"
    (click)="goToTeamPage(team.id)"
  ></mtg-team-card>
  <a href="javascript:;" [routerLink]="createTeamRoute" class="btn btn-link create-team-link">{{ localization.createTeam }}</a>
</div>
